/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC41NjI0OSAyLjI4OTA2TDEyLjU3MTQgMTMuNzE3NkgxMC4zNTEzTDkuNjAwNjQgMTEuMzE3Nkg1LjI1NjM2TDQuNTA1NyAxMy43MTc2SDIuMjg1NjRMNi4yOTQ1MiAyLjI4OTA2SDguNTYyNDlaTTcuNDI4NSA0LjM0NjIxTDUuODE1MzcgOS41MDUzOUg5LjAyNTY2TDcuNDI4NSA0LjM0NjIxWiIgZmlsbD0iYmxhY2siLz48L3N2Zz4=";